import { useContext } from "react";

import { BoardSettingsContext, IBoardSettingsContext } from "./BoardSettingsContext";

export function useBoardSettings(): IBoardSettingsContext {
  const context = useContext(BoardSettingsContext);
  if (!context) {
    throw new Error("useBoardSettings must be used within a BoardSettingsProvider");
  }

  return context;
}
